module.exports = __webpack_public_path__ + "static/media/needs (1).86a27291.svg";